import { render, staticRenderFns } from "./tableCom.vue?vue&type=template&id=b082d8ca&scoped=true"
import script from "./tableCom.vue?vue&type=script&lang=js"
export * from "./tableCom.vue?vue&type=script&lang=js"
import style0 from "./tableCom.vue?vue&type=style&index=0&id=b082d8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b082d8ca",
  null
  
)

export default component.exports